import React from "react";
import ChrCommonDateRange from "../../../../../utils/CustomObject/ChrCommonDateRange";
import { isEmpty, pick } from "../../../../../utils/CoreExtensions/ObjectExtensions";
import { MeetingConstants } from "../../../Meeting/templates/constants";

const ComparisonTooltip = (props) => {
  if (isEmpty(pick(props, "periodOne", "periodTwo")))
    return "";

  const formattedDate = (date) => date.format(MeetingConstants.DESCRIPTIVE_DATE_FORMAT);
  const comparisonLineItem = (periodProps) => {
    const { dateRangeStr, presetStr, value } = periodProps;
    let { fromDate, toDate } = ChrCommonDateRange.getComponentsFromDateString(dateRangeStr);
    [fromDate, toDate] = [fromDate, toDate].map(dateString => moment(dateString, MeetingConstants.DATE_FORMAT));
    return (
      <div className="d-flex flex-gap-10 justify-content-between">
        <div className="d-flex flex-gap-5 align-items-center">
          <div>
            { presetStr }
          </div>
          <div className="font-10 text-muted">
            { `(${formattedDate(fromDate)} - ${formattedDate(toDate)})` }
          </div>
        </div>
        <div>
          { value }
        </div>
      </div>
    );
  };

  return (
    <div className="d-flex flex-column flex-gap-5 px-1 py-2">
      { props.periodOne &&
        comparisonLineItem(props.periodOne)
      }
      { props.periodTwo &&
        comparisonLineItem(props.periodTwo)
      }
    </div>
  );
};

export default ComparisonTooltip;